import GlobalVariables from '../GlobalVariables';

const addStyleText = function (text, id, before) {
    const defaultSheetId = 'apexchat_default';
    try {
        let cssNode = null;
        id = id || defaultSheetId;
        cssNode = document.getElementById(id);
        if (!cssNode) {
            cssNode = document.createElement('style');
            cssNode.type = 'text/css';
            cssNode.rel = 'stylesheet';
            cssNode.media = 'screen';
            if (id) {
                cssNode.id = id;
            }
        }
        // running cache of styles so we don't query the dom; fixes a bug in <= IE7 where dom querying blows up
        if (!GlobalVariables.Styles[id]) {
            GlobalVariables.Styles[id] = '';
        }
        GlobalVariables.Styles[id] += text;

        if (cssNode.styleSheet) {
            cssNode.styleSheet.cssText = GlobalVariables.Styles[id];
        } else {
            cssNode.appendChild(document.createTextNode(text));
        }
        if (window.ApexChat.nonceValue) {
            cssNode.nonce = window.ApexChat.nonceValue;
        }
        if (before) {
            document
                .getElementsByTagName('head')[0]
                .insertBefore(cssNode, document.getElementsByTagName('head')[0].firstChild);
        } else {
            document.getElementsByTagName('head')[0].appendChild(cssNode);
        }
    } catch (ex) {
        if (window.console) {
            window.console.error(ex);
        }
    }
};
export default addStyleText;

